import { createProvider } from '@nvision/services/data-provider';

import type { TransportationModeFilters } from '../../models';
import * as api from './api';
import { normalizeTransportationModeFilters, normalizeTransportationModes } from './normalize';

export const fetchTransportationModes = createProvider(
  (filters: Partial<TransportationModeFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchTransportationModes(normalizeTransportationModeFilters(filters), { signal }),
).andThen((res) => normalizeTransportationModes(res));
